import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AuthConfigModule } from './auth/auth-config.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { LoginComponent } from './login/login.component';
import { LandingPageComponent } from './landing-page/landing-page.component';
import { HeaderComponent } from './shared/header/header.component';
import { BannerComponent } from './shared/banner/banner.component';
import { ProductSelectionComponent } from './product-selection/product-selection.component';
import { CookieModule, CookieService } from 'ngx-cookie';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TokenInterceptorService } from './services/token-interceptor.service';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { PdfViewerComponent } from './pdf-viewer/pdf-viewer.component';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { LoaderComponent } from './shared/loader/loader.component';
import { LoaderInterceptor } from './services/loader-interceptor.service';
import { ErrorPopupComponent } from './shared/error-popup/error-popup.component';
import { ErrorService } from '../app/services/error.service';
import { UnauthorizedComponent } from './unauthorized/unauthorized.component';

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    LandingPageComponent,
    HeaderComponent,
    BannerComponent,
    ProductSelectionComponent,
    PdfViewerComponent,
    LoaderComponent,
    ErrorPopupComponent,
    UnauthorizedComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    AuthConfigModule,
    FormsModule,
    ReactiveFormsModule,
    PdfViewerModule,
    CookieModule.forRoot(),
    NgbModule
  ],
  providers: [ErrorService, CookieService,{ provide: HTTP_INTERCEPTORS, useClass: TokenInterceptorService, multi: true },{ provide: HTTP_INTERCEPTORS, useClass: LoaderInterceptor, multi: true }],
  bootstrap: [AppComponent]
})
export class AppModule { }
